import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { DescriptionStationComponent } from './components/description-station/description-station.component';
import { IBDComponent } from './components/ibd/ibd.component';
import { IBGNComponent } from './components/ibgn/ibgn.component';
import { MPCEComponent } from './components/mpce/mpce.component';
import { InterventionListComponent } from './components/intervention-list/intervention-list.component';
import { InterventionDashboardComponent } from './components/intervention-dashboard/intervention-dashboard.component';
import { PlanPrelevementComponent } from './components/plan-prelevement/plan-prelevement.component';
import { ENavigationRoute } from './models/enum/navigation-route';
import { AnalysisComponent } from './components/analysis/analysis.component';
import { AddPhotoComponent } from './components/add-photo/add-photo.component';
import { DocumentsComponent } from './components/documents/documents.component';
import { AnalysisListComponent } from './components/analysis-list/analysis-list.component';
import { EauComponent } from './components/eau/eau.component';
import { NotationComponent } from './components/notation/notation.component';
import { PictureViewerComponent } from './components/picture-viewer/picture-viewer.component';
import { ExportComponent } from './components/export/export.component';
import { CanNavigateGuard } from './tools/guards/navigation-guard';
import { TakePhotoComponent } from './components/take-photo/take-photo.component';
import { ErrorComponent } from './error.component';
import { LacComponent } from './components/lac/lac.component';
import { MetrologieComponent } from './components/metrologie/metrologie.component';
import { RoleGuard } from './tools/guards/role.guard';
import { RedirectComponent } from './components/redirect/redirect.component';
import { AdminImportComponent } from './components/admin-import/admin-import.component';
import { MGCEComponent } from './components/mgce/mgce.component';
import { IBMRComponent } from './components/ibmr/ibmr.component';
import { IMLComponent } from './components/iml/iml.component';
import { AnalyseIbmrComponent } from './components/analyse-ibmr/analyse-ibmr.component';
import { AnalyseCyanoComponent } from './components/analyse-cyano/analyse-cyano.component';
import { LogistiqueComponent } from './components/logistique/logistique.component';
import { SamplingPointMapComponent } from './components/sampling-point-map/sampling-point-map.component';

const routes: Routes = [
    { path: '', pathMatch: 'full', redirectTo: ENavigationRoute.InterventionList },
    { path: ENavigationRoute.DescriptionStation, component: DescriptionStationComponent, canDeactivate: [CanNavigateGuard] },
    { path: ENavigationRoute.IBD, component: IBDComponent, canDeactivate: [CanNavigateGuard] },
    { path: ENavigationRoute.IBGN, component: IBGNComponent, canDeactivate: [CanNavigateGuard] },
    { path: ENavigationRoute.MPCE, component: MPCEComponent, canDeactivate: [CanNavigateGuard] },
    { path: ENavigationRoute.EAU, component: EauComponent, canDeactivate: [CanNavigateGuard] },
    { path: ENavigationRoute.LAC, component: LacComponent, canDeactivate: [CanNavigateGuard] },
    { path: ENavigationRoute.MGCE, component: MGCEComponent, canDeactivate: [CanNavigateGuard] },
    { path: ENavigationRoute.IBMR, component: IBMRComponent, canDeactivate: [CanNavigateGuard] },
    { path: ENavigationRoute.IML, component: IMLComponent, canDeactivate: [CanNavigateGuard] },
    { path: ENavigationRoute.InterventionList, component: InterventionListComponent, canActivate: [RoleGuard] },
    { path: ENavigationRoute.InterventionDashboard, component: InterventionDashboardComponent, canDeactivate: [CanNavigateGuard] },
    { path: ENavigationRoute.PlanPrelevement, component: PlanPrelevementComponent, canDeactivate: [CanNavigateGuard] },
    { path: ENavigationRoute.Analyse, component: AnalysisComponent },
    { path: ENavigationRoute.AnalyseIBMR, component: AnalyseIbmrComponent },
    { path: ENavigationRoute.AnalyseCyano, component: AnalyseCyanoComponent },
    { path: ENavigationRoute.AnalyseList, component: AnalysisListComponent, canActivate: [RoleGuard] },
    { path: ENavigationRoute.Photo, component: AddPhotoComponent },
    { path: ENavigationRoute.PhotoViewer, component: TakePhotoComponent },
    { path: ENavigationRoute.Documents, component: DocumentsComponent, canActivate: [RoleGuard] },
    { path: ENavigationRoute.Exports, component: ExportComponent, canActivate: [RoleGuard] },
    { path: ENavigationRoute.Notation, component: NotationComponent },
    { path: ENavigationRoute.DocumentViewer, component: PictureViewerComponent },
    { path: ENavigationRoute.Metrologie, component: MetrologieComponent, canActivate: [RoleGuard] },
    { path: ENavigationRoute.Logistique, component: LogistiqueComponent, canActivate: [RoleGuard] },
    { path: ENavigationRoute.SamplingPointMap, component: SamplingPointMapComponent, canActivate: [RoleGuard] },
    { path: ENavigationRoute.Error, component: ErrorComponent },
    { path: ENavigationRoute.Admin, component: AdminImportComponent },
    { path: 'redirect', component: RedirectComponent },
    { path: '**', component: InterventionListComponent }
];

@NgModule({
    imports: [RouterModule.forRoot(routes, { onSameUrlNavigation: 'reload' })],
    exports: [RouterModule]
})
export class AppRoutingModule { }
